import { Component, createContext, useContext, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';

import useUpdateEffect from 'utils/hooks/useUpdateEffect';

export const PAGE_ERROR_TYPE = {
  notFound: 0,
  unhandled: 1
};

const errorsContext = createContext({
  error: null,
  setError: _.noop,
  clearError: _.noop
});

export const usePageError = () => useContext(errorsContext);

class PageErrorBoundary extends Component {
  static contextType = errorsContext;

  static getDerivedStateFromError() {
    return {};
  }

  componentDidCatch() {
    this.context.setError(PAGE_ERROR_TYPE.unhandled);
  }

  render() {
    return this.props.children;
  }
}

export const PageErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);

  const { pathname } = useLocation();

  const contextValue = useMemo(
    () => ({
      error,
      setError,
      clearError: () => setError(null)
    }),
    [error]
  );

  useUpdateEffect(() => setError(null), [pathname]);

  return (
    <errorsContext.Provider value={contextValue}>
      <PageErrorBoundary>{children}</PageErrorBoundary>
    </errorsContext.Provider>
  );
};
